import React from "react";
import { AlertTriangle, CalendarDays } from "lucide-react";
import { statusInfo } from "./allocUtils";
import { AvatarStack } from "./AvatarStack";
import { BudgetBar } from "./BudgetBar";
import { fmtDate } from "../pnl/format";

export function ProjectCard({ p, rows, pnl, overCount, selected, onSelect }) {
  const st = statusInfo(p.status);
  return (
    <div role="button" tabIndex={0} onClick={onSelect} onKeyDown={(e) => (e.key === "Enter" || e.key === " ") && (e.preventDefault(), onSelect())}
      data-testid={`assign-project-${p.code}`}
      className={`w-full text-left bg-white border rounded-xl p-4 transition-[border-color,box-shadow,transform] duration-200 hover:-translate-y-px
        ${selected ? "border-brand shadow-[0_0_0_3px_rgba(61,104,177,0.12)]" : "border-neutral-200 hover:border-slate-300 hover:shadow-sm"} cursor-pointer focus:outline-none focus-visible:border-brand`}>
      <div className="flex items-start justify-between gap-2">
        <div className="min-w-0">
          <div className="font-mono text-[10px] tracking-wider text-ink-muted">{p.code}</div>
          <div className="font-display font-semibold text-[15px] leading-snug text-ink truncate">{p.name}</div>
          {p.client_name && <div className="text-[12px] text-ink-muted truncate">{p.client_name}</div>}
        </div>
        <span className={`shrink-0 inline-flex items-center gap-1.5 px-2 py-0.5 rounded-full text-[10px] font-medium ring-1 ring-inset ${st.cls}`}>
          <span className={`h-1.5 w-1.5 rounded-full ${st.dot}`} />{st.label}
        </span>
      </div>
      <div className="mt-2 flex items-center gap-1.5 text-[11px] text-ink-muted">
        <CalendarDays className="h-3.5 w-3.5" /> {fmtDate(p.start_date)} → {fmtDate(p.end_date)}
      </div>
      <div className="mt-3 flex items-center justify-between gap-2">
        <AvatarStack people={rows.map((a) => ({ id: a.employee_id, name: a.employee?.name }))} testid={`project-avatars-${p.code}`} />
        {overCount > 0 && (
          <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-red-50 text-red-700 text-[10px] font-semibold" data-testid={`project-overalloc-${p.code}`}>
            <AlertTriangle className="h-3 w-3" /> {overCount} {overCount > 1 ? "supraalocați" : "supraalocat"}
          </span>
        )}
      </div>
      {pnl !== undefined && <div className="mt-3"><BudgetBar totals={pnl?.totals} compact testid={`project-budgetbar-${p.code}`} /></div>}
    </div>
  );
}
